import { c as _c } from "react/compiler-runtime";
interface Props {
  isLoading: boolean;
}
export const BlogEmptyState = t0 => {
  const $ = _c(1);
  const {
    isLoading
  } = t0;
  if (isLoading) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-center text-muted-foreground py-12" aria-live="polite">No blog posts are available yet. Please check back later.</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
};